import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CourseList = _resolveComponent("CourseList")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_CourseList, {
      onRowClicked: _ctx.openCourseSubjectList,
      appId: _ctx.appId,
      name: _ctx.name
    }, null, 8, ["onRowClicked", "appId", "name"])
  ]))
}